import React from "react";
import { useSiteStructureQueryQuery } from "../../generated/graphql";
import { GraphQlSelect } from "./GraphQlSelect";
import { GraphQlSelectId } from "./GraphQlSelectId";

export const SiteStructureSelect = (props) => {
    const query = useSiteStructureQueryQuery();
    const filteredData = props.hideDigitalGroup
        ? query.data?.siteStructures.filter(
            item => item.siteStructureGroup && item.siteStructureGroup.name !== "DIGITAL"
        )
        : query.data?.siteStructures;
    return props.valueIsId ? <GraphQlSelectId queryResult={{ ...query, data: { siteStructures: filteredData } }} {...props} labelField="name" /> : <GraphQlSelect queryResult={{ ...query, data: { siteStructures: filteredData } }} {...props} labelField="name" />;
}
